import url from '@/creditflowresearch/infrastructure/url';

const CORPORATE_BOND_SCREENER_URL = '/corporate-bond-screener';

export const getCorporateBondScreenerMetaSchema = () => ({
  '@type': 'WebPage',
  url: url.getUrl(CORPORATE_BOND_SCREENER_URL),
  name: 'Fixed Income Corporate Bond Screener',
  description: 'Use our fixed income screener for global corporate bonds for free. Filter 40,000+ bonds across all sectors using dozens of criteria.',
  keywords: ['investment grade', 'high yield', 'corporate bonds', 'bond screener'],
});
